import LovService from "./LovService";

export default LovService;
